<template>
  <el-dropdown placement="bottom-start">
    <el-badge
      :value="`+${ids.length - 1}`"
      class="item"
      type="info"
      v-if="ids.length > 1"
    >
      <span v-text="ids[0]" class="first-account-id" />
    </el-badge>
    <span v-text="ids[0]" class="first-account-id" v-else />
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="(v, i) in customer.amocrm"
        v-text="[v.account_id, v.domain].join(' - ')"
        :key="i"
      />
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import SharedCustomers from "../../../store/classes/SharedCustomers";

export default {
  name: "AccountIdsColumnContent",
  props: {
    customer: SharedCustomers
  },
  computed: {
    ids() {
      return this.customer.account_ids;
    }
  }
};
</script>

<style scoped lang="stylus">
.first-account-id
    cursor pointer
    padding-right 10px
</style>
